<!--
  TeleworkListRowInfo.vue
    Tlework List Row Information Component
-->

<!-- -------------------------------------------------------------------------------- -->
<template>
  <div> <!-- @Memo Vue Componentはひとつの要素のみである必要があるため<div>で囲っておく -->
    <v-layout row wrap align-center justify-center class="hm-twl-row">
      <!--日付-->
      <v-flex
      class="hm-twl-cell hm-twl-cell-day"
      >
        {{ pTeleworkInfo.dispDate }}
      </v-flex>
      <!--休暇種別-->
      <v-flex
      class="hm-twl-cell hm-twl-cell-category hm-twl-cell-hover"
      :class="{'hm-twl-td-updated':checkHolidayUpdated}"
      @click="editHolidayData(pTeleworkInfo.list_row, pTeleworkInfo.holidayId, pTeleworkInfo.holidayCategory, pTeleworkInfo.date, pTeleworkInfo.holidayComment, pTeleworkInfo.holidayUpdateDate)"
      >
        <div :class="{'hm-twl-cell-dated':checkStartDated}">
          {{ holidayCategoryNameDisp }}
        </div>
      </v-flex>
      <!--勤務開始-->
      <v-flex
      class="hm-twl-cell hm-twl-cell-hover"
      :class="{'hm-twl-td-updated':checkStartUpdated}"
      @click="editTeleworkData(pTeleworkInfo.list_row, pTeleworkInfo.startId, mTeleworkCategory.START, pTeleworkInfo.date, pTeleworkInfo.startTime, pTeleworkInfo.startComment, pTeleworkInfo.startUpdateDate)"
      >
        <div :class="{'hm-twl-cell-dated':checkStartDated}">
          {{ pTeleworkInfo.startTime }}
        </div>
      </v-flex>
      <!--離席-->
      <v-flex
      class="hm-twl-cell hm-twl-cell-hover"
      :class="{'hm-twl-td-updated':checkLeaveUpdated}"
      @click="editTeleworkData(pTeleworkInfo.list_row, pTeleworkInfo.leaveId, mTeleworkCategory.LEAVE, pTeleworkInfo.date, pTeleworkInfo.leaveTime, pTeleworkInfo.leaveComment, pTeleworkInfo.leaveUpdateDate)"
      >
        <div :class="{'hm-twl-cell-dated':checkLeaveDated}">
          <span>{{ pTeleworkInfo.leaveTime.split('/').length === 3 ? pTeleworkInfo.leaveTime.slice(5) : pTeleworkInfo.leaveTime }}</span>
        </div>
      </v-flex>
      <!--着席-->
      <v-flex
      class="hm-twl-cell hm-twl-cell-hover"
      :class="{'hm-twl-td-updated':checkSeatedUpdated}"
      @click="editTeleworkData(pTeleworkInfo.list_row, pTeleworkInfo.seatedId, mTeleworkCategory.SEATED, pTeleworkInfo.date, pTeleworkInfo.seatedTime, pTeleworkInfo.seatedComment, pTeleworkInfo.seatedUpdateDate)"
      >
        <div :class="{'hm-twl-cell-dated':checkSeatedDated}">
          <span>{{ pTeleworkInfo.seatedTime.split('/').length === 3 ? pTeleworkInfo.seatedTime.slice(5) : pTeleworkInfo.seatedTime }}</span>
        </div>
      </v-flex>
      <!--勤務終了-->
      <v-flex
      class="hm-twl-cell hm-twl-cell-hover"
      :class="{'hm-twl-td-updated':checkEndUpdated}"
      @click="editTeleworkData(pTeleworkInfo.list_row, pTeleworkInfo.endId, mTeleworkCategory.END, pTeleworkInfo.date, pTeleworkInfo.endTime, pTeleworkInfo.endComment, pTeleworkInfo.endUpdateDate)"
      >
        <div :class="{'hm-twl-cell-dated':checkEndDated}">
          <span>{{ pTeleworkInfo.endTime.split('/').length === 3 ? pTeleworkInfo.endTime.slice(5) : pTeleworkInfo.endTime }}</span>
        </div>
      </v-flex>
      <!--勤務時間-->
      <v-flex
      class="hm-twl-cell hm-twl-cell-wh"
      >
        {{ pTeleworkInfo.working_hours }}
      </v-flex>
      <!--離席時間-->
      <v-flex
      class="hm-twl-cell hm-twl-cell-lh"
      >
        {{ pTeleworkInfo.leaving_hours }}
      </v-flex>
    </v-layout>
  </div>
</template>

<!-- -------------------------------------------------------------------------------- -->
<script>
import { mapState } from 'vuex'
import { TeleworkCategory, HolidayCategoryNamesShort, HolidayCategoryDiff } from '@/common'

export default {
  name: 'TeleworkListRowInfo',
  props: [ 'pTeleworkInfo' ],
  data: () => ({
    mTeleworkCategory: TeleworkCategory,
    mHolidayCategoryNames: HolidayCategoryNamesShort,
    mHolidayCategoryDiff: HolidayCategoryDiff,
  }),
  components: {
  },
  mounted: function () {
    this.$log.debug('# TeleworkListRowInfo')
  },
  destroyed: function () {
    this.$log.debug('# TeleworkListRowInfo')
  },
  computed: {
    ...mapState({
    }),
    // -------------------------------------------------------------------------
    // 編集有無判定
    checkStartUpdated: function () {
      return (this.pTeleworkInfo.startUpdateDate !== '')
    },
    checkLeaveUpdated: function () {
      return (this.pTeleworkInfo.leaveUpdateDate !== '')
    },
    checkSeatedUpdated: function () {
      return (this.pTeleworkInfo.seatedUpdateDate !== '')
    },
    checkEndUpdated: function () {
      return (this.pTeleworkInfo.endUpdateDate !== '')
    },
    checkHolidayUpdated: function () {
      return (this.pTeleworkInfo.holidayUpdateDate !== '')
    },
    // -------------------------------------------------------------------------
    // 日またぎデータ判定(アプリ版のみ)
    checkStartDated: function () {
      return (this.$store.getters.isMobile && this.pTeleworkInfo.startTime.length > 5)
    },
    checkLeaveDated: function () {
      return (this.$store.getters.isMobile && this.pTeleworkInfo.leaveTime.length > 5)
    },
    checkSeatedDated: function () {
      return (this.$store.getters.isMobile && this.pTeleworkInfo.seatedTime.length > 5)
    },
    checkEndDated: function () {
      return (this.$store.getters.isMobile && this.pTeleworkInfo.endTime.length > 5)
    },
    // -------------------------------------------------------------------------
    // 休暇種別名称設定
    holidayCategoryNameDisp: function () {
      return this.mHolidayCategoryNames[Number(this.pTeleworkInfo.holidayCategory) - this.mHolidayCategoryDiff - 1]
    },
  },
  methods: {
    // -------------------------------------------------------------------------
    //  勤務時間セルクリック
    editTeleworkData: function (row_no, workinghour_id, category, date, time, comment, update_date) {
      //this.$log.debug('★[editTeleworkData] date：' + date + '、time：' + time)
      let input_date = date     // YYYY-MM-DD形式
      let input_time = time     // hh:mm形式(日またぎの場合はMM/DD hh:mm、年またぎの場合はYYYY/MM/DD hh:mm)
      if (input_time.indexOf('/') > -1) {
        // 日またぎの場合('/'がある場合を日またぎとみなす)
        if (input_time.split('/').length === 3) {
          // 年またぎ
          input_date = time.slice(0, 4) + '-' + time.slice(5, 7) + '-' + time.slice(8, 10)
          input_time = time.slice(11)
        }
        else {
          // 日or月またぎ
          input_date = date.slice(0, 5) + time.slice(0, 2) + '-' + time.slice(3, 5)
          input_time = time.slice(6)
        }
      }

      const send_obj = {
        list_row: row_no,
        workinghour_id: workinghour_id,
        category: category,
        date: input_date,     // YYYY-MM-DD形式(DataPicker用)
        time: input_time,     // hh:mm形式(TimePicker用)
        comment: comment,
        linked_date: date.replace(/-/g, ''),    // YYYYMMDD形式
        update_date: update_date
      }

      // 親コンポーネントの編集ダイアログ表示処理を呼び出す
      this.$emit('teleworkInfoSelected', send_obj)
    },
    // -------------------------------------------------------------------------
    //  休暇種別セルクリック
    editHolidayData: function (row_no, workinghour_id, category, date, comment, update_date) {
      this.$log.debug('★[editHolidayData] category：' + category + '、date：' + date)

      const send_obj = {
        list_row: row_no,
        workinghour_id: workinghour_id,
        category: category,
        date: date,            // YYYY-MM-DD形式(DataPicker用)
        comment: comment,
        update_date: update_date
      }

      // 親コンポーネントの編集ダイアログ表示処理を呼び出す
      this.$emit('holidayInfoSelected', send_obj)
    }
  }
}
</script>

<!-- -------------------------------------------------------------------------------- -->
<style scoped>
.hm-twl-row {
  height: 35px;
  line-height: 35px;
  width: 100%;
}
.hm-twl-cell {
  height: 100%;
  width: 80px;
  text-align: center;
  font-size: 0.9em;
  color: rgba(0,0,0,.87);
  white-space: nowrap;
  overflow: hidden;
}
.hm-twl-cell-hover {
  transition: all 0.1s ease 0s;
  cursor: pointer;
}
.hm-twl-cell-hover:hover {
  background: #dbdbdb;
}
.hm-twl-cell-day {
  border-right: solid 1px rgba(0,0,0,.12);
}
.hm-twl-cell-category {
  border-right: solid 1px rgba(0,0,0,.12);
}
.hm-twl-cell-wh {
  border-left: solid 1px rgba(0,0,0,.12);
}
@media screen and (max-width: 645px) {
  /* 幅～645px */
  .hm-twl-cell-wh,
  .hm-twl-cell-lh {
    display: none;
  }
  .hm-twl-cell {
    width: calc(100% / 6);
  }
}
.hm-twl-td-updated {
  font-weight: bold;
  color: #005FFF;
}
.hm-twl-cell-dated {
  height: 100%;
  transform: scale(0.7, 0.9);
}
@media screen and (max-width: 400px) {
.hm-twl-cell-dated {
  transform: scale(0.6, 0.9);
}
}
</style>



// WEBPACK FOOTER //
// src/components/TeleworkListRowInfo.vue